module.exports = __webpack_public_path__ + "static/media/360-degree.7e5bacc2.svg";